<template>
  <div class="headerCate">

    <div class="infoUpdate">
      <div class="ContainerRecorda">
        <v-icon style="font-size: 65px;" color="orange">mdi-alert-circle</v-icon>
        <p>
          <span>
            {{ $t('starAssignment.label.listZen.title') }}
          </span>
        </p>
      </div>
    </div>

    <h1>{{ $t('starAssignment.label.requestZen') }}</h1>

    <v-data-table 
      :headers="headers" 
      :items="requestsZen" 
      :header-props="{ class: 'red-header' }"
      :search="searchTerm"
      :no-data-text="$t('chart.label.notData') || 'No hay datos disponibles'"
        :footer-props="{ 'items-per-page-text': $t('label.rowsPerPage.title') }"
    >
      <!-- Sección superior de la tabla -->
      <template v-slot:top>
        <div style="margin-bottom: 50px">
          <div class="row justify-space-between mx-auto">
            <v-text-field
              :label="$t('label.search.title')"
              :placeholder="$t('label.search.text')"
              append-icon="mdi-magnify"
              dense
              outlined
              class="col-md-5"
              @input="search"
            ></v-text-field>
          </div>
        </div>
      </template>

      <!-- Fecha solicitud -->
      <template v-slot:[`item.requestDate`]="{ item }">
        <span class="custom-font">{{ formattedDate(item.requestDate) }}</span>
      </template>

      <!-- Usuario origen -->
      <template v-slot:[`item.approverName`]="{ item }">
        <span class="custom-font">{{ item.approverName }}</span>
      </template>
      
      <!-- Solicitante -->
      <template v-slot:[`item.applicantsName`]="{ item }">
        <span class="custom-font">{{ item.applicantsName }}</span>
      </template>

      <!-- Tiempo -->
      <template v-slot:[`item.requestHours`]="{ item }">
        <span class="custom-font">{{ item.requestHours }}</span>
      </template>

      <!-- Acción -->
      <template v-slot:[`item.action`]="{item}">
        <changeStarZen :starZen="item"/>
      </template>

    </v-data-table>
  </div>
</template>

<script>
import changeStarZen from "@/views/star_assignment/star_assignment_zen/components/change_state_star_zen_page.vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

import {
  STARASSIGNMENT_M,
  GET_ZEN_STAR_REQUESTS,
  ACTION_LIST_ZEN_STAR_REQUESTS
} from "@/views/star_assignment/store/types/types.js";


export default {
  name: "listCategoriaComponent",
  components: {
    changeStarZen
  },
  data() {
    return {
      searchTerm: "",
    };
  },

  async mounted() {
    await this.ActionGetListRequestsZen();
  },

  methods: {
    ...mapActions({
      ActionGetListRequestsZen: `${STARASSIGNMENT_M}${ACTION_LIST_ZEN_STAR_REQUESTS}`,
    }),

    search() {
      this.searchTerm = event.target.value;
    },

    formattedDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },
  },

  computed: {
    ...mapGetters({
      requestsZen: [`${STARASSIGNMENT_M}${GET_ZEN_STAR_REQUESTS}`],
    }),

    headers() {
      return [
        {
          text: this.$t('starAssignment.label.table.dateRequest'),
          value: "requestDate",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('starAssignment.label.table.originUser'),
          value: "approverName",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('starAssignment.label.table.applicant'),
          value: "applicantsName",
          sortable: false,
          align: "center",
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: this.$t('starAssignment.label.table.time'),
          value: "requestHours",
          align: "center",
          sortable: false,
          class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          value: "action",
          sortable: false,
          width: "2%",
          class: "primary--text font-weight-medium text-subtitle-1",
        },
      ];
    }, 

  },
  
};
</script>

<style lang="css" scoped>

  .headerCate h1 {
    margin-bottom: 30px;
  }

  .headerCate {
    display: flex;
    gap: 40px;
    flex-direction: column;
    margin-top: 20px;
    margin-left: 20px;
  }

  .actions v-icon {
    font-size: 24px;
  }
  .custom-font {
    font-size: 20px;
  }
  /* Define los estilos (Tipo de letra) para las etiquetas h1,h2,h3,h4,h5,h6   */
  body {
    font-family: "Nunito Sans", sans-serif;
  }
  
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: "Amsi Pro", sans-serif;
    color: #2d0049;
    font-weight: normal;
  }
/* Estilos para el botón de eliminar */
  .btnDetails .v-icon {
    color: #6E17A5;
    margin-bottom: 19px;
  }

  /**estilo de los iconos */
  .actions{
    display:flex;
       
  }

  img{
    width: 3rem;
    height: 3rem;
    filter: grayscale(100%) brightness(50%) contrast(150%) hue-rotate(270deg);
  }

  .infoUpdate{
    display: flex;
    background-color: rgba(255, 119, 0, 0.363);
    border-radius: 15px;
    padding: 2%;
    justify-content: center;
    align-items: center;
    gap: 15px;
  }

  p span {
    color: #6e17a5;
    font-weight: bold;
    font-size: 15px;
  }

  .ContainerRecorda {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  @media screen and (max-width: 768px) {

    p span {
      font-size: 12px;
    }
  }

  @media screen and (max-width: 414px) {
        
    h1{
        font-size:3vh;
        margin-left:2vh
    }

  }

  @media screen and (min-width: 414px) {
      
    h1{
      font-size:4vh;
      margin-left:2vh
    }

  }

  @media screen and (max-width: 280px) { 

    h1{
      font-size:3vh;
      margin-left:2vh
    }
    h2{
      font-size:2vh;
    }
  } 

</style>
